import { ILocationService } from 'angular';
import { TransitionService } from '@uirouter/angularjs';
import { AuthService } from '../../core/services/auth/auth.service';
import { AccessService } from '../../core/services/access.service';
import { ModalService } from '../../components/modals/gmc-modal/gmc-modal.service';
import { IInfoModalData } from '../../shared/components/info-modal/info-modal.component';
import { ProfileService } from '../../core/services/profile/profile.service';
import { CvService } from '../../core/services/cv.service';

export function dashboardGuard( $transitions: TransitionService,
                                $location: ILocationService ) {
  $transitions.onEnter({ to: 'app.dashboard.**' }, async ( transition ) => {
    const accessService = transition.injector().get('AccessService') as AccessService;
    const cvService = transition.injector().get('CvService') as CvService;
    const authService = transition.injector().get('AuthService') as AuthService;
    const profileService = transition.injector().get('ProfileService') as ProfileService;
    const modalService = transition.injector().get('ModalService') as ModalService;
    console.log(transition);

    const $state = transition.router.stateService;
    if ( !authService.isLoggedIn() ) {
      return $state.target('app.public.auth.login');
    }
    const to = transition.to().name;
    const from = transition.from().name;
    const target = to.includes('dashboard.profile') || to.includes('dashboard.cv');
    const fromTarget = from.includes('dashboard.cv');

    if ( authService.user.baseRoleName === 'Candidate' ) {
      let isAccess: boolean;
      await accessService.checkAccess()
        .then(( access ) => {
          isAccess = access;
        });
      if ( !isAccess && target) {
        return true;
      } else if (!isAccess && !target && !fromTarget) {
        return $state.target('app.dashboard.cv');
      } else if (!isAccess && fromTarget) {
        if ( !(to.includes('dashboard.profile') || to.includes('dashboard.cv')) ) {
          const infoModalData: IInfoModalData = {
            text: 'Please, enter data to the all obligated fields in the tabs "Personal Info" and "Job Requirements"',
            title: 'Additional info',
            buttonText: 'OK'
          };
          const modal = await modalService.showModal({
            backdrop: true,
            component: 'infoModal',
            extraClasses: 'modal-dialog-centered-1',
            data: infoModalData
          });
          await modal.close;
          if ( modal.close ) {
            return $state.target($state.$current.name);
          }
        }
      } else if ($state.target('app.dashboard.top-vacancy') && to.includes('top-vacancy')) {
        const res = await cvService.getFillPoints();
        if (res < 50) {
          const data: IInfoModalData = {
            text: 'This action was rejected. CV must be filled at least 50%',
            buttonText: 'OK'
          };
          await modalService.showModal({
            component: 'infoModal',
            extraClasses: 'modal-dialog-centered-1',
            data
          });
          return $state.target($state.$current.name);
        }
      }
      return true;
    }

    if ( authService.user.baseRoleName === 'Employer' ) {
      if ( to && !(to.includes('dashboard.profile')) ) {
        let hasHiringOn = [];
        await profileService.getHiringOnData().then(( res: any[] ) => {
          res.map(( value ) => value.value).forEach(( value ) => {
            hasHiringOn = [ ...hasHiringOn, ...value ];
          });
        });
        const infoModalData: IInfoModalData = {
          text: 'Enter required information inside the chapter"',
          title: 'Additional info',
          buttonText: 'OK',
          example: {
            message1: '*We are hiring on:',
            message2: 'Chose the Section and Job/Vessel type'
          }
        };
        if ( !hasHiringOn.length ) {
          await $state.go('app.dashboard.profile');
          const modal = await modalService.showModal({
            backdrop: true,
            component: 'infoModal',
            extraClasses: 'modal-dialog-centered-1',
            data: infoModalData
          });
          await modal.close;
          if ( modal.close ) {
            return $state.target('app.dashboard.profile');
          }
        }
      }
    }
  });
}

dashboardGuard.$inject = [
  '$transitions',
  '$location',
  'AuthService'
];



// WEBPACK FOOTER //
// ./app/states/dashboard/dashboard.guard.ts